"use client";

import { Box } from "@mui/material";
import cn from "clsx";
import { forwardRef } from "react";
import { CarouselContentProps } from "../lib/type";
import { useCarousel } from "./CarouselWrapper";

const CarouselContent = forwardRef<
  HTMLDivElement,
  CarouselContentProps & { wrapperClassName?: string }
>(({ className, wrapperClassName, ...props }, ref) => {
  const { carouselRef, orientation } = useCarousel();

  return (
    <Box ref={carouselRef} className={cn("overflow-hidden", wrapperClassName)}>
      <Box
        ref={ref}
        className={cn(
          "flex",
          orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
          className,
        )}
        {...props}
      />
    </Box>
  );
});
CarouselContent.displayName = "CarouselContent";
export { CarouselContent };
